import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export function ChassisComExcecao({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "modelCode",
      flex: 1,
      headerName: t("digitalServicePlan.modelCode"),
      headerClassName: "header-style",
    },
    {
      field: "vin",
      flex: 1,
      headerName: t("digitalServicePlan.vin"),
      headerClassName: "header-style",
    },
    {
      field: "modelYear",
      flex: 1,
      headerName: t("digitalServicePlan.modelYear"),
      headerClassName: "header-style",
    },
  ];
  return (
    <DataGridApi
      params1="&param="
      labelParams1="Chassi"
      host={CONFIG.SOB_API}
      endPoint={`excel/warranty/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
